import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

document.documentElement.style.background = "#F7F2E9";

createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
